import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { slugs } from "../../../Constant/slugs";
import { AdsGETApiAuth, AdsPUTApi } from "../../../Constant/api";
import DataTable from "react-data-table-component";

const columns = [
  {
    id: 1,
    name: "id",
    selector: (row) => row.id,
    sortable: true,
    reorder: true,
    width: "100px"
  },
  {
    id: 2,
    name: "Name",
    selector: (row) => row.meta.name,
    sortable: true,
    reorder: true
  },
   {
    id: 3,
    name: "Phone",
    selector: (row) => row.meta.phone,
    sortable: true,
    reorder: true
  },
   {
    id: 4,
    name: "Address",
    selector: (row) => row.meta.address,
    sortable: true,
    reorder: true
  },
   {
    id: 5,
    name: "Status",
    selector: (row) => row.meta.is_active,
    sortable: true,
    reorder: true
  },
  {
    id: 31,
    name: "View",
    cell: (row) => <Link to={`${slugs.employee_details}${row.slug}`}>View</Link>,

  }
];

export default function AllEmployee() {
  const [Projects1, setProjects1] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const [deleteUsersModal, setDeleteUsersModal] = React.useState(false)
  const [serachName, setSearchName] = React.useState("")

  const GetAllProjects = (params) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth(
      {
        per_page: 10000,
        _fields: "id,title,slug,meta",
        "filter[meta_query][1][key]": "type",
        "filter[meta_query][1][value][0]": `Staff`,
        "filter[meta_query][1][compare]": "=",

      }, slugs.db_slug_employee)
      .then((res) => {
        setProjects1(res.data)
        setCustomersList(res.data)
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  useEffect(() => {
    GetAllProjects()
  }, [])


  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>All Staff</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Staff
        </div>
      </div>
      <a href={slugs.new_employee}>
        <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}>
          Add New Staff
        </div>
      </a>


      <div className="row">
        <div className="col-md-6">
          <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setCustomersList(Projects1)
              }}
            >
              All ({Projects1.length}) |
            </div>
          </div>
          <div style={{ display: "inline", cursor: "pointer" }}>
            <div style={{ display: "inline-block", margin: "0px 5px" }}
              onClick={() => {
                setDeleteUsersModal(Projects1)
              }}
            >
              Delete All
            </div>
          </div>
        </div>
        <div className="col-md-6 row">
          <div className="col-6" />
          <input className="col-6" style={{ margin: "1px 2px", padding: "3px 2px" }}
            value={serachName} placeholder="Name"
            onChange={(event) => {
              setSearchName(event.target.value)
              setCustomersList(Projects1.filter(a => a.title.rendered.includes(event.target.value)))
            }}
          />
        </div>
      </div>
      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        <DataTable
          columns={columns}
          data={CustomersList}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          striped
          // sortIcon={<SortIcon />}
          paginationPerPage={100}
          paginationRowsPerPageOptions={[10, 50, 100, 1000]}
          pagination
          selectableRows
        />
      </div>
      {deleteUsersModal &&
        <section className="modal" >
          <div className="row" style={{ overflow: "hidden" }}>
            <div className="col-md-3 col-1"></div>
            <div className="col-md-6 col-10  shadow bg-white">
              <div style={{ margin: " 10px", overflowX: 'hidden', border: "1px solid #999", padding: "9px" }}>
                <div style={{ cursor: 'pointer', textAlign: 'right', padding: "0px 20px", fontWeight: "800" }}
                  onClick={() => {
                    setDeleteUsersModal(false)
                  }}
                >X</div>
                Do you really want to Delete all the employee?<br />
                <div className="row">
                  <div className="col-3 center " >
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        setDeleteUsersModal(false)
                      }}
                    >
                      Cancel
                    </div>
                  </div>
                  <div className="col-3 center">
                    <div className="sign-in-button-4" style={{ width: "80%" }}
                      onClick={() => {
                        for (let i = 0; i < Projects1.length; i++) {
                          setReload(true)
                          setDeleteUsersModal(false)
                          AdsPUTApi({
                            status: "draft"
                          }, slugs.db_slug_employee, Projects1[i].id)
                            .then((res) => {
                              if (i == Projects1.length - 1) {
                                GetAllProjects()
                              }
                            })
                            .catch((err) => {
                              console.log(err)
                            })

                        }
                      }}
                    >
                      Delete all employee
                    </div>
                  </div>
                </div>
                <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px", border: "1px solid #999" }}>
                  <DataTable
                    paginationPerPage={100}
                    paginationRowsPerPageOptions={[10, 50, 100, 1000]}
                    columns={columns}
                    data={Projects1}
                    defaultSortFieldId={1}
                    defaultSortAsc={false}
                    striped
                    // sortIcon={<SortIcon />}
                    pagination
                    selectableRows={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

      }
      {Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
    </div>
  )
}